import React, { Component } from "react";

class Resume extends Component {
  getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    let skillmessage = "";
    let work = [];
    let projects = [];
    let skills = [];
    let education = [];

    if (this.props.data) {
      if (this.props.data.education) {
        let edc = this.props.data.education;

        education = edc.map(function (education) {
          return (
            <div key={education.url}>
              <h3>{education.course}</h3>
              <h2 style={{ color: "#95A3A3" }}>{education.institution}</h2>
              <p className="info">
                {education.studyType} <span>&bull;</span>
                <em className="date">{education.endDate}</em>
              </p>
              {/* <p>{education.course}</p>*/}
            </div>
          );
        });
      }

      if (this.props.data.skills) {
        let softskills = this.props.data.skills.softskills;
        let hardskills = this.props.data.skills.hardskills;

        skillmessage = "";

        skills.push(
          hardskills.map((skills) => {
            let className = "bar-expand " + skills.name.toLowerCase();
            return (
              <li key={skills.name}>
                <span
                  style={{ width: skills.level, backgroundColor: "#394147" }}
                  className={className}
                >
                  <span
                    style={{
                      float: "right",
                      fontWeight: "bold",
                      color: "#11ABB0",
                    }}
                  >
                    {skills.level}
                  </span>
                </span>
                <em>{skills.name}</em>
              </li>
            );
          })
        );

        skills.push(
          softskills.map((skills) => {
            let className = "bar-expand " + skills.name.toLowerCase();
            return (
              <li key={skills.name}>
                <span
                  style={{ width: skills.level, backgroundColor: "#394147" }}
                  className={className}
                >
                  <span
                    style={{
                      float: "right",
                      fontWeight: "bold",
                      color: "#11ABB0",
                    }}
                  >
                    {skills.level}
                  </span>
                </span>
                <em>{skills.name}</em>
              </li>
            );
          })
        );
      }

      if (this.props.data.work) {
        let workArr = this.props.data.work;

        workArr.map((jobEntry) => {
          if (jobEntry.projects) {
            projects = [];
            let projectsArr = jobEntry.projects;

            projects.push(
              projectsArr.map(function (project) {
                return (
                  <div key={project.name}>
                    <p className="info">
                      {project.name}
                      <span>&bull;</span>{" "}
                      <em className="date">{project.role}</em>
                    </p>
                    <p>{project.description}</p>
                    <p>{project.technologies}</p>
                  </div>
                );
              })
            );
          } else {
            projects = [];
          }

          return work.push(
            <div key={jobEntry.name}>
              <h3 style={{ color: "white" }}>{jobEntry.name}</h3>
              <h4>{jobEntry.position}</h4>
              <p className="info">
                {" "}
                <em className="date">{jobEntry.startDate}</em> -{" "}
                <em className="date">{jobEntry.endDate}</em>
              </p>
              <ul>
                <li>{projects}</li>
              </ul>
              <p>{jobEntry.description}</p>
            </div>
          );
        });
      }
    }

    return (
      <section id="resume">
        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Work</span>
            </h1>
          </div>

          <div style={{ paddingTop: "1rem" }} className="nine columns main-col">
            {work}
          </div>
        </div>

        <div className="row skill">
          <div className="three columns header-col">
            <h1 style={{ paddingTop: "2rem" }}>
              <span>Skills</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <p>{skillmessage}</p>

            <div className="bars">
              <ul className="skills">{skills}</ul>
            </div>
          </div>
        </div>

        <br />
        <br />

        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>Education</span>
            </h1>
          </div>

          <div style={{ paddingTop: "1rem" }} className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">{education}</div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Resume;
